import { Schema } from 'effect/index';

export class PostAuthResponse extends Schema.Class<PostAuthResponse>('PostAuthResponse')({
  apiUrl: Schema.String,
  redirectUrl: Schema.String,
  isBeta: Schema.Boolean,
  phoneVerificationRequired: Schema.Boolean,
}) {}

// Proper way to extend Schema.Class without changes, we get the same response in case of 400 error
export class PostAuthResponseError extends Schema.Class<PostAuthResponseError>('PostAuthResponseError')(
  PostAuthResponse.fields,
) {}

export class UpdatePhoneResponse extends Schema.Class<UpdatePhoneResponse>('UpdatePhoneResponse')({
  success: Schema.Literal(true),
}) {}

export class SendCodeResponse extends Schema.Class<SendCodeResponse>('SendCodeResponse')({
  status: Schema.Literal(true),
}) {}

export class VerifyCodeResponse extends Schema.Class<VerifyCodeResponse>('VerifyCodeResponse')({
  status: Schema.Literal(true),
}) {}

export class SkipPhoneUpdateResponse extends Schema.Class<SkipPhoneUpdateResponse>('SkipPhoneUpdateResponse')({
  success: Schema.Literal(true),
}) {}

export class GetCountryByIpResponse extends Schema.Class<GetCountryByIpResponse>('GetCountryByIpResponse')({
  country: Schema.String,
  country_name: Schema.String,
  country_calling_code: Schema.String,
}) {}

export class GenericResponseError extends Schema.Class<GenericResponseError>('GenericResponseError')({
  error: Schema.String,
}) {}

export class PostAuthError extends Schema.Class<PostAuthError>('PostAuthError')({
  message: Schema.optional(Schema.String),
  type: Schema.optional(Schema.String),
}) {}
